import { useState } from 'react';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: '당도 편차가 있나요?',
      answer: '자연 그대로의 포도를 사용하기 때문에 수확 시기와 기후에 따라 당도가 14~16 °Brix 범위에서 다소 차이가 있을 수 있습니다. 이는 무첨가 제품의 자연스러운 특성이며, 품질에는 전혀 문제가 없습니다.'
    },
    {
      question: '침전물이 생기는 이유는 무엇인가요?',
      answer: '저온 착즙 과정에서 포도의 천연 성분이 그대로 보존되어 시간이 지나면 자연스럽게 침전물이 생길 수 있습니다. 이는 무첨가 제품의 정상적인 현상이며, 섭취 전 가볍게 흔들어 드시면 됩니다. 품질이나 안전성에는 전혀 문제가 없습니다.'
    },
    {
      question: '보관 방법과 유통기한은 어떻게 되나요?',
      answer: '냉장 보관(0~10°C)을 권장하며, 제조일로부터 6개월간 신선하게 드실 수 있습니다. 개봉 후에는 가능한 빨리 섭취해 주시기 바랍니다. 냉동 보관은 권장하지 않습니다.'
    },
    {
      question: '어린이나 임산부도 섭취할 수 있나요?',
      answer: '본 제품은 포도 100%로 만든 무첨가 제품으로 어린이와 임산부 모두 안심하고 드실 수 있습니다. 다만, 개인의 건강 상태나 알레르기가 있는 경우 전문의와 상담 후 섭취하시기 바랍니다. 당 함량이 있으므로 당뇨 환자는 주의가 필요합니다.'
    },
    {
      question: '하루 권장 섭취량은 얼마인가요?',
      answer: '성인 기준 하루 1~2팩(100~200mL)을 권장합니다. 과다 섭취 시 당 섭취량이 높아질 수 있으므로 적정량을 드시는 것이 좋습니다. 개인의 건강 상태에 따라 조절하시기 바랍니다.'
    },
    {
      question: '다른 포도즙과 어떤 차이가 있나요?',
      answer: '화악산 암반 대수층 지하수로 세척하고, 열원을 사용하지 않는 저온 착즙 방식으로 제조하여 포도 본연의 향과 영양을 최대한 보존합니다. 물, 설탕, 향료 등 어떠한 첨가물도 넣지 않은 100% 포도즙입니다. 모든 검사 성적서를 투명하게 공개합니다.'
    },
    {
      question: '무농약 인증은 어떻게 확인하나요?',
      answer: '국립농산물품질관리원에서 발급한 무농약 인증서를 보유하고 있으며, 인증번호와 유효기간을 제품 상세 페이지에서 확인하실 수 있습니다. 또한 정기적인 잔류농약 검사 성적서도 함께 공개하고 있습니다.'
    },
    {
      question: '배송은 얼마나 걸리나요?',
      answer: '주문 후 2~3일 이내 출고되며(영업일 기준), 지역에 따라 1~2일 내 수령 가능합니다. 제주 및 도서산간 지역은 추가 배송일이 소요될 수 있습니다. 신선도 유지를 위해 냉장 배송으로 발송됩니다.'
    }
  ];

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            자주 묻는 질문
          </h2>
          <p className="text-lg text-gray-600">
            궁금하신 점을 확인해보세요.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-[#FDFBF7] rounded-xl border border-gray-200 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                <span className="font-bold text-lg text-gray-900 pr-4">
                  {faq.question}
                </span>
                <i className={`ri-arrow-down-s-line text-2xl text-[#6B4E9C] transition-transform flex-shrink-0 ${
                  openIndex === index ? 'rotate-180' : ''
                }`}></i>
              </button>
              
              {openIndex === index && (
                <div className="px-6 pb-5">
                  <p className="text-gray-700 leading-relaxed">
                    {faq.answer}
                  </p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gradient-to-r from-[#6B4E9C]/10 to-purple-100/30 rounded-xl p-8 text-center">
          <h3 className="text-xl font-bold text-gray-900 mb-3">
            더 궁금하신 점이 있으신가요?
          </h3>
          <p className="text-gray-700 mb-6">
            고객센터를 통해 언제든지 문의해주세요. 친절하게 답변드리겠습니다.
          </p>
          <div className="flex flex-wrap items-center justify-center gap-6">
            <div className="flex items-center gap-2 text-gray-700">
              <i className="ri-phone-line text-[#6B4E9C] text-xl"></i>
              <span className="font-semibold">1588-XXXX</span>
            </div>
            <div className="flex items-center gap-2 text-gray-700">
              <i className="ri-mail-line text-[#6B4E9C] text-xl"></i>
              <span className="font-semibold">support@example.com</span>
            </div>
            <div className="flex items-center gap-2 text-gray-700">
              <i className="ri-time-line text-[#6B4E9C] text-xl"></i>
              <span className="font-semibold">평일 09:00 - 18:00</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}